import { missionEntityName } from '../../../../backend/features/mission/shared';
import { shiftEntityName } from '../../../../backend/features/shift/shared';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { TextCell, useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { requireAnyOrgPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { usePermission, useUserState } from '@juvare/contact-management/ui/hooks';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import { minutesToMilliseconds } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';
export const useOngoingMissionsTable = () => {
    const { t } = useMissionsTranslation();
    const userState = useUserState();
    const dateNow = React.useMemo(() => Date.now(), []);
    const { timeForOngoingShift } = useSelector(getSettings);
    const { requireAnySystemPermission } = usePermission();
    const allowManageAllMissions = requireAnySystemPermission('manage-missions');
    const { dataTableProps } = useDataTableUsingState({
        useDataProvider: ({ limit, offset, sortColumnKey, sortColumnDesc }) => {
            const response = useStorageList(missionEntityName, {
                filter: [
                    {
                        op: 'in',
                        idSubFilter: {
                            entity: shiftEntityName,
                            column: 'missionId',
                            filter: [
                                {
                                    column: 'startTime',
                                    op: '<=',
                                    value: dateNow + minutesToMilliseconds(timeForOngoingShift.timeBeforeShiftStart),
                                },
                                {
                                    column: 'stopTime',
                                    op: '>=',
                                    value: dateNow - minutesToMilliseconds(timeForOngoingShift.timeAfterShiftEnd),
                                },
                            ],
                        },
                    },
                    ...(!allowManageAllMissions ? getLowerLevelAdminFilters(userState) : []),
                ],
                limit,
                offset,
                orderBy: [
                    {
                        column: sortColumnKey,
                        desc: sortColumnDesc,
                    },
                ],
            });
            return Object.assign(Object.assign({}, response), { data: response.data
                    ? {
                        rows: response.data.rows,
                        filteredRowCount: response.data.total,
                    }
                    : undefined, reload: () => {
                    void response.mutate();
                } });
        },
        defaultSortColumnKey: 'createdAt',
        defaultSortColumnDesc: true,
        rowSelectionEnabled: true,
        defaultRowsPerPage: 3,
    });
    const columns = React.useMemo(() => [
        {
            headerLabel: t('shifts.ongoingShifts.missionNameLabel'),
            sortKey: 'name',
            cellFunction: ({ columns }) => React.createElement(TextCell, null, columns.name),
        },
        {
            headerLabel: t('shifts.ongoingShifts.missionStatusLabel'),
            sortKey: 'status',
            cellFunction: ({ columns }) => React.createElement(TextCell, null, columns.status),
        },
    ], [t]);
    return {
        dataTableProps: Object.assign(Object.assign({}, dataTableProps), { columns }),
    };
};
const getLowerLevelAdminFilters = (userState) => {
    const activeOrganizationIds = Object.keys(userState.orgRole);
    const manageableActiveOrganizationIds = activeOrganizationIds.filter((id) => requireAnyOrgPermission(userState, id, 'manage-organization', 'manage-members'));
    return [
        { column: 'organizationSharing', op: 'overlap', value: manageableActiveOrganizationIds },
        { column: 'typeId', op: 'in', value: userState.authorizedMissionTypeIds },
    ];
};
